import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';
import { companyInfo } from '../mock';

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  const location = useLocation();
  if (location.pathname.startsWith('/sign/')) return null;
  if (location.pathname.startsWith('/card') || location.pathname === '/connect' || location.pathname.startsWith('/driver/')) return null;

  return (
    <footer className="bg-burgundy-deep text-white/70 grain-overlay" data-testid="site-footer">
      <div className="container mx-auto px-4 py-16 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Company Info */}
          <div>
            <img
              src={companyInfo.logo}
              alt={companyInfo.name}
              className="h-24 w-auto mb-5"
            />
            <p className="font-display text-gold text-lg mb-2">{companyInfo.tagline}</p>
            <p className="text-sm text-white/50 leading-relaxed">With over {companyInfo.experience} years of experience in heavy vehicle logistics across Singapore.</p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-gold text-xs font-semibold uppercase tracking-[0.25em] mb-5">Quick Links</h3>
            <ul className="space-y-3">
              {[
                { name: 'Home', path: '/' },
                { name: 'Services', path: '/services' },
                { name: 'About Us', path: '/about' },
                { name: 'Gallery', path: '/gallery' },
                { name: 'Book Now', path: '/booking' },
                { name: 'Contact', path: '/contact' },
                { name: 'Terms & Conditions', path: '/terms' },
              ].map(l => (
                <li key={l.path}>
                  <Link to={l.path} className="text-sm hover:text-gold transition-colors">{l.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-gold text-xs font-semibold uppercase tracking-[0.25em] mb-5">Our Services</h3>
            <ul className="space-y-3">
              <li className="text-sm">Lorry Crane (25–100 Ton)</li>
              <li className="text-sm">Tailgate Box Lorry</li>
              <li className="text-sm">Trailer Services</li>
              <li className="text-sm">Manpower Supply</li>
              <li className="text-sm">Warehouse Storage</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-gold text-xs font-semibold uppercase tracking-[0.25em] mb-5">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-sm">
                <MapPin size={16} className="mt-0.5 flex-shrink-0 text-gold" />
                <span>{companyInfo.address}</span>
              </li>
              <li className="flex items-center gap-3 text-sm">
                <Phone size={16} className="text-gold" />
                <a href={`tel:${companyInfo.phone}`} className="hover:text-gold transition-colors">{companyInfo.phone}</a>
              </li>
              <li className="flex items-center gap-3 text-sm">
                <Mail size={16} className="text-gold" />
                <a href={`mailto:${companyInfo.email}`} className="hover:text-gold transition-colors">{companyInfo.email}</a>
              </li>
            </ul>

            <div className="flex gap-5 mt-7">
              <a href="#" aria-label="Facebook" className="text-white/40 hover:text-gold transition-colors">
                <Facebook size={19} />
              </a>
              <a href="#" aria-label="Instagram" className="text-white/40 hover:text-gold transition-colors">
                <Instagram size={19} />
              </a>
              <a href="#" aria-label="LinkedIn" className="text-white/40 hover:text-gold transition-colors">
                <Linkedin size={19} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gold/10 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/40">
          <p>&copy; {currentYear} {companyInfo.name}. All rights reserved.</p>
          <p className="uppercase tracking-[0.2em]">Swift · Secure · Reliable</p>
        </div>
      </div>
    </footer>
  );
};
